import React, { Component } from "react";
import { Redirect } from "react-router";
import { Col, Container, Row } from "reactstrap";
import { connect } from "react-redux";
import { GuessCard, ResultBarCard } from "../../components/card";
import greatJob from "../../assets/images/tw/great-job.png";
import mystryWordImg from "../../assets/images/tw/mystry-word-img.png";
import _ from "lodash";
class CurrentRoundResult extends Component {
  render() {
    const roomData = this.props.gameReducer.roomObj;
    let activePlayerName = "";
    let activePlayerImage = "";
    let allUsers = roomData.users;
    if (roomData) {
      if (!roomData.active_game) {
        return <Redirect to={"/lobby"} />;
      }
      if (roomData.game_state) {
        if (roomData.game_state.status === "Joining") {
          return <Redirect to={"/lobby"} />;
        }
        if (roomData.game_state.status === "Over") {
          return <Redirect to={"/final-result"} />;
        }
        if (
          roomData.game_state.status === "Clues" ||
          roomData.game_state.status === "Evaluating" ||
          roomData.game_state.status === "Guessing" ||
          roomData.game_state.status === "Judging"
        )
          return <Redirect to={"/game"} />;
        const activePlayer = allUsers.find(
          (user) => user.player_id === roomData.game_state.active_player
        );
        if (activePlayer) {
          activePlayerName = activePlayer.display_name;
          activePlayerImage = activePlayer.profile_image;
        }
      }
    }
    let activePlayerGuess = "";
    let mysteryWord = "";
    let resultWord = "GREAT JOB!";
    let gif = "https://media.giphy.com/media/srg19CG0cKMuI/giphy.gif";
    if (!roomData.correct_guess) {
      gif = "https://media1.giphy.com/media/1QhmDy91F9veMRLpvK/giphy.gif";
    }

    if (roomData?.game_state?.mystery_word?.word) {
      mysteryWord = roomData.game_state.mystery_word.word;
    }

    if (roomData?.game_state?.game_outputs?.tabletop_text_top) {
      resultWord = roomData.game_state.game_outputs.tabletop_text_top;
      gif = roomData.game_state.game_outputs.tabletop_url;
    }
    if (roomData?.game_state?.guess) {
      activePlayerGuess = roomData.game_state.guess;
    }

    let wrongWords = [];
    let rightWords = [];

    const maxRounds =
      _.get(roomData, "game_state.game_parameters.total_rounds") || 2;

    if (roomData) {
      if (roomData?.game_state?.wrong_words) {
        wrongWords = roomData.game_state.wrong_words;
      }
      if (roomData?.game_state?.right_words) {
        rightWords = roomData.game_state.right_words;
      }
    }
    if (
      roomData.game_state.status === "Over"
      // ||
      // !roomData.active_game ||
      // rightWords.length + wrongWords.length === maxRounds
    )
      return <Redirect to={"/final-result"} />;
    if (roomData.game_state.status === "Clues")
      return <Redirect to={"/game"} />;
    else {
      return (
        <>
          <div className="gamesWrapper">
            <Container>
              <Row className="justify-content-center">
                <Col lg={10} xl={10}>
                  <div className="resultCard2 result2 text-center">
                    <div className="contentWrap2">
                      <div className="contentWrap2-great">
                        <h2>{resultWord}</h2>
                      </div>

                      <div className="gifWrapper2">
                        {/* <img src={gif} className="img" alt="gif" /> */}
                        {/* <img src={greatJob} className="img" alt="gif" /> */}
                      </div>
                    </div>
                  </div>
                </Col>
              </Row>
            </Container>
            {/* <div className="resultCard result text-center">
              <div>
                <div className="contentWrap">
                  <h2>{resultWord}</h2>
                  <div className="gifWrapper">
                    <img src={gif} alt="gif" />
                  </div>
                </div>
              </div>
            </div> */}

            <>
              <Row className="tw-great-job-rows">
                <Col md={6} className="guess-cols">
                  <GuessCard
                    image={activePlayerImage}
                    personName={activePlayerName}
                    btnText={activePlayerGuess}
                    mysteryWord={mysteryWord}
                  />
                </Col>
                <Col md={6}>
                  {/* <ResultBarCard size="sm" text={mysteryWord} /> */}
                  {/* <div className="text-center">
                    <p className="result-bar-bottom">Mystery Word</p>
                  </div> */}
                  <div className="tw-final-mystry-word">
                    <div className="text-center">
                      <img
                        src={mystryWordImg}
                        className="img-fluid mystryWordImg"
                        alt="image"
                      />
                    </div>
                    <div className="mystry-word">
                      <p className="word">{mysteryWord}</p>
                    </div>
                  </div>
                </Col>
              </Row>
            </>
          </div>
        </>
      );
    }
  }
}

const mapStateToProps = (state) => ({
  gameReducer: state.gameReducer,
});

export default connect(mapStateToProps, null)(CurrentRoundResult);
